// Grid size for asset positioning and alignment
export const GridSize = 16;
